import { Action } from '@ngrx/store';
import { Associate } from '@quorum/models/xs-resource';

export enum AssociatesEntityActionTypes {
  GetAssociateFromServer = '[Associates] Get Associate From Server',
  GetAssociateFromServerError = '[Associates] Get Associate From Server Error',
  GetAssociateFromServerSuccess = '[Associates] Get Associate From Server Success',
  UpdateAssociateOnServer = '[Associates] Update Associate On Server',
  UpdateAssociateOnServerError = '[Associates] Update Associate On Server Error',
  UpdateAssociateOnServerSuccess = '[Associates] Update Associate On Server Success',
  CreateAssociateOnServer = '[Associates] Create Associate From Server',
  CreateAssociateOnServerError = '[Associates] Create Associate From Server Error',
  CreateAssociateOnServerSuccess = '[Associates] Create Associate From Server Success',
}

//#region message-types
export class GetAssociateFromServer implements Action {
  readonly type = AssociatesEntityActionTypes.GetAssociateFromServer;
  constructor(public payload: { params: { associateId: string }; returnAction: any }) {}
}
export class GetAssociateFromServerError implements Action {
  readonly type = AssociatesEntityActionTypes.GetAssociateFromServerError;
  constructor(public payload: any) {}
}
export class GetAssociateFromServerSuccess implements Action {
  readonly type = AssociatesEntityActionTypes.GetAssociateFromServerSuccess;
  constructor(public payload: Associate[]) {}
}

export class UpdateAssociateOnServer implements Action {
  readonly type = AssociatesEntityActionTypes.UpdateAssociateOnServer;
  constructor(public payload: Associate) {}
}
export class UpdateAssociateOnServerError implements Action {
  readonly type = AssociatesEntityActionTypes.UpdateAssociateOnServerError;
  constructor(public payload: any) {}
}
export class UpdateAssociateOnServerSuccess implements Action {
  readonly type = AssociatesEntityActionTypes.UpdateAssociateOnServerSuccess;
  constructor(public payload: Associate) {}
}

export class CreateAssociateOnServer implements Action {
  readonly type = AssociatesEntityActionTypes.CreateAssociateOnServer;
  constructor(public payload: Associate) {}
}
export class CreateAssociateOnServerError implements Action {
  readonly type = AssociatesEntityActionTypes.CreateAssociateOnServerError;
  constructor(public payload: any) {}
}
export class CreateAssociateOnServerSuccess implements Action {
  readonly type = AssociatesEntityActionTypes.CreateAssociateOnServerSuccess;
  constructor(public payload: Associate) {}
}
//#endregion

export type AssociatesEntityAction =
  | GetAssociateFromServer
  | GetAssociateFromServerError
  | GetAssociateFromServerSuccess
  | UpdateAssociateOnServer
  | UpdateAssociateOnServerError
  | UpdateAssociateOnServerSuccess
  | CreateAssociateOnServer
  | CreateAssociateOnServerError
  | CreateAssociateOnServerSuccess;

export const fromAssociatesEntityActions = {
  GetAssociateFromServer,
  GetAssociateFromServerError,
  GetAssociateFromServerSuccess,
  UpdateAssociateOnServer,
  UpdateAssociateOnServerError,
  UpdateAssociateOnServerSuccess,
  CreateAssociateOnServer,
  CreateAssociateOnServerError,
  CreateAssociateOnServerSuccess,
};
